module.exports = __webpack_public_path__ + "static/Calibre-Regular-e08232148510aade507c2af9bb66acd0.woff";